<template>
  <div class="main cart-page order-page page-inside">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">SHOPPING CART</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <section class="section page-body-section cart-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="form left">
            <div class="desc desc-36">PAYMENT DETAILS</div>
            <div class="form-wrapper">
              <div class="form-fields">
                <div class="form-fields-wrapper">
                  <div class="label-list">
                    <label>
                      <div class="desc medium" :placeholder="$t('First name')">
                        {{ $t("First name") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('First name')"
                        v-model="name"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Last Name')">
                        {{ $t("Last Name") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Last Name')"
                        v-model="surname"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Email')">
                        {{ $t("Email") }}:
                      </div>
                      <input
                        type="email"
                        :placeholder="$t('Email')"
                        v-model="email"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Nickname')">
                        {{ $t("Nickname") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Nickname')"
                        v-model="nickname"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Phone')">
                        {{ $t("Phone") }}:
                      </div>
                      <input
                        type="number"
                        :placeholder="$t('Phone')"
                        v-model="phone"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Address')">
                        {{ $t("Address") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Address')"
                        v-model="address"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('City')">
                        {{ $t("City") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('City')"
                        v-model="city"
                      />
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Country')">
                        {{ $t("Country") }}:
                      </div>
                      <select v-model="country">
                        <option v-for="item in countryOptions" :key="item.id">
                          {{ $t(item.title) }}
                        </option>
                      </select>
                    </label>
                    <label>
                      <div class="desc medium" :placeholder="$t('Zip Code')">
                        {{ $t("Zip Code") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Zip Code')"
                        v-model="zipCode"
                      />
                    </label>
                  </div>
                  <div class="cta-container">
                    <div class="chekbox-container">
                      <label class="chekbox-label">
                        <div class="chekbox-label-wrapper">
                          <input type="checkbox" name="terms" v-model="terms" />
                          <div class="checkbox"></div>
                          <span class="desc">{{ $t("I agree with") }} </span>
                          <a @click="$parent.goToPrivacy()" class="desc">
                            {{ $t("privacy policy") }}</a
                          >
                          <span class="desc"> {{ $t("and") }} </span>
                          <a @click="$parent.goToTerms()" class="desc">
                            {{ $t("terms and conditions") }}</a
                          >
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="desc desc-32">PAYMENT METHOD</div>
            <div class="button-container">
              <label>
                <input type="radio" v-model="paymentType" value="balance" />
                <div class="radio">
                  <img src="../images/coin2.svg" />
                  <span class="desc medium">Balance</span>
                </div>
              </label>
              <label v-for="method in paymentMethods" :key="method.id">
                <input type="radio" v-model="paymentType" :value="method.id" />
                <div class="radio">
                  <img
                    v-if="methodImage(method)"
                    :src="methodImage(method)"
                    :alt="methodTitle(method)"
                  />
                  <span v-else class="desc medium">{{ methodTitle(method) }}</span>
                </div>
              </label>
            </div>
            <div class="desc desc-32">{{ $t("TOTAL") }}:</div>
            <div class="desc desc-56">
              <b>{{ $parent.totalSum }}</b>
              <b class="currency">{{ $parent.currency }}</b>
            </div>
            <button
              @click="submit()"
              :class="[
                'button small rounded w-274',
                { disabled: !requiredFieldsAreFilled },
              ]"
            >
              COMPLETE ORDER
            </button>
            <transition name="slide">
              <div v-if="$parent.error" class="error-desc desc red">
                {{ $parent.error }}
              </div>
            </transition>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registration",
  props: ["currency"],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      phone: "",
      surname: "",
      nickname: "",
      country: "",
      countryId: "",
      countryOptions: "",
      city: "",
      address: "",
      zipCode: "",
      terms: false,
      paymentType: "",
    };
  },

  watch: {
    currency: function () {
      if (this.currency) {
        this.getCurr();
      }
    },
    country: function () {
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.country === this.countryOptions[i].title) {
          this.countryId = this.countryOptions[i].id;
          break;
        }
      }
      this.countryId;
    },
  },
  mounted() {
    this.getProfile();
    this.getCounties();

    if (this.currency) {
      this.getCurr();
    }
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.countryId &&
        this.city &&
        this.address &&
        this.zipCode &&
        this.terms &&
        this.email &&
        this.nickname
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    paymentMethods() {
      const settings = this.$parent.settings;
      return (settings && settings.payment_methods) || [];
    },
  },
  methods: {
    methodImage(method) {
      return method.image || method.logo || method.icon || "";
    },
    methodTitle(method) {
      return method.title || method.name || "";
    },
    getCurr() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile?currency=" + this.currency)
        .then((res) => {
          this.balance = res.data.balance;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    submit() {
      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        email: this.email,
        nickname: this.nickname,
        country: this.countryId,
        city: this.city,
        address: this.address,
        postCode: this.zipCode,
        currency: this.$parent.currency,
      };
      if (this.paymentType === "balance") {
        data.paymentType = "balance";
      } else {
        data.payment_method_id = this.paymentType;
      }
      this.$emit("orderSubmit", data);
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch(() => {});
    },
    getProfile() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.email = res.data.email;
          this.nickname = res.data.nickname;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
  },
};
</script>
